import React from "react"
import styles from "./Button.module.scss"
const ButtonMedium = (props: any) => {
    return (
        <button {...props} className={`${styles.button_medium} ${props.className}`}>
            {props.children}
        </button>
    )
}

export default ButtonMedium
